// constants
import { showSuccessAlert } from "../../constants/alerts";
import { VideoActionTypes } from "./constants";

const INIT_STATE = {
  videos: [],
  loading: false,
  initialLoading: false,
  error: null,
};

interface VideoData {
  id: number;
  name: string;
  day: string;
  video: File;
  subCourseId: string;
}

interface VideoActionType {
  type:
    | VideoActionTypes.API_RESPONSE_SUCCESS
    | VideoActionTypes.API_RESPONSE_ERROR
    | VideoActionTypes.CREATE_VIDEO
    | VideoActionTypes.UPDATE_VIDEO
    | VideoActionTypes.GET_VIDEO
    | VideoActionTypes.DELETE_VIDEO;
  payload: {
    actionType?: string;
    data?: VideoData | {};
    error?: string;
    videos?: [];
  };
}

interface State {
  videos?: VideoData[] | [];
  loading?: boolean;
  value?: boolean;
}

const VideoStates = (
  state: State = INIT_STATE,
  action: VideoActionType
): any => {
  switch (action.type) {
    case VideoActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case VideoActionTypes.CREATE_VIDEO: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case VideoActionTypes.GET_VIDEO: {
          return {
            ...state,
            loading: false,
            initialLoading: false,
            videos: action.payload.data,
          };
        }
        case VideoActionTypes.UPDATE_VIDEO: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        case VideoActionTypes.DELETE_VIDEO: {
          showSuccessAlert(action.payload.data);
          return {
            ...state,
            loading: false,
            error: null,
          };
        }
        default:
          return { ...state };
      }

    case VideoActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case VideoActionTypes.CREATE_VIDEO: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        case VideoActionTypes.UPDATE_VIDEO: {
          return {
            ...state,
            loading: false,
            error: action.payload.error,
          };
        }
        case VideoActionTypes.GET_VIDEO: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
            initialLoading: false,
          };
        }
        case VideoActionTypes.DELETE_VIDEO: {
          return {
            ...state,
            error: action.payload.error,
            loading: false,
          };
        }
        default:
          return { ...state };
      }

    case VideoActionTypes.CREATE_VIDEO:
      return { ...state, loading: true };
    case VideoActionTypes.UPDATE_VIDEO:
      return { ...state, loading: true };
    case VideoActionTypes.GET_VIDEO:
      return { ...state, loading: true, initialLoading: true };
    case VideoActionTypes.DELETE_VIDEO:
      return { ...state, loading: true };
    default:
      return { ...state };
  }
};

export default VideoStates;
